import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';

import {
  SwitchingProfileComponent,
  SwitchingProfileDisplay
} from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { AnalyticsDataPopulateService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { SwitchProfileFacadeService } from '../../data-access/facades/switch-profile/switch-profile-facade.service';

@Component({
  selector: 'idp-switch-profile',
  standalone: true,
  imports: [CommonModule, SwitchingProfileComponent, PushPipe],
  templateUrl: './switch-profile.component.html',
  styleUrls: ['./switch-profile.component.scss']
})
export class SwitchProfileComponent implements OnInit {
  @Input() flyoutToggle = false;
  @Output() flyoutToggleChange = new EventEmitter<boolean>(false);
  facade = inject(SwitchProfileFacadeService);
  private analyticsService = inject(AnalyticsDataPopulateService);

  emptySwitchProfileDetails = {} as SwitchingProfileDisplay;

  ngOnInit(): void {
    this.facade.init();
  }

  handleAnalytics(event: Event): void {
    if (event?.currentTarget) {
      this.analyticsService.populateAnalyticsData(
        event.currentTarget as HTMLElement,
        event,
        undefined,
        true
      );
    }
  }
}
